// import React from "react";

// function isClassComponent(component) {
//     return (
//         typeof component === 'function' &&
//         !!component.prototype.isReactComponent
//     )
// }
//
// function isFunctionComponent(component) {
//     return (
//         typeof component === 'function' &&
//         String(component).includes('return React.createElement')
//     )
// }

// function isReactComponent(component) {
//     return (
//         isClassComponent(component) ||
//         isFunctionComponent(component)
//     )
// }

// function isElement(element) {
//     return React.isValidElement(element);
// }

// function isDOMTypeElement(element) {
//     return isElement(element) && typeof element.type === 'string';
// }
//
// function isCompositeTypeElement(element) {
//     return isElement(element) && typeof element.type === 'function';
// }

function fileInputToBlob(file) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = function (evt) {
        const metadata = `name: ${file.name}, type: ${file.type}, size: ${file.size}, contents:`;
        const contents = evt.target.result;
        resolve({
          metadata,
          contents,
        })
      };
      reader.readAsDataURL(file);
    } catch (e) {
      reject(e)
    }
  })
}

function shallowEqual(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (
      !hasOwnProperty.call(objB, keysA[i]) ||
      !Object.is(objA[keysA[i]], objB[keysA[i]])
    ) {
      return false;
    }
  }
  return true;
}

import { compile as compileFn, match as matchFn } from "path-to-regexp";

const compileRoute = (route, params = null) => {
  return compileFn(route, { encode: encodeURIComponent })(params || {});
}

const compileTemplate = (route, params = null) => {
  return compileFn(route, {})(params || {});
}

const matchRoute = matchFn

function containsSpecialChars(str) {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  return specialChars.test(str);
}

function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

const isNumeric = (num) => (typeof (num) === 'number' || (typeof (num) === "string" && num.trim() !== '' && (parseInt(num) + '').length === num.length)) && !isNaN(num);


const formatListArray = (listArr) => {
  const formattedData = {};

  listArr && listArr?.forEach(item => {
    const group = item?.group;
    const value = item?.value;
    if (group == null || group === "" || value == null || value === "") {
      return;
    }

    if (!formattedData[group]) {
      formattedData[group] = {
        label: group,
        options: [],
      };
    }

    formattedData[group]?.options?.push({
      value: item.value,
      label: item.label,
    });
  });

  return Object.values(formattedData);
}

function formatSaddleDiscipline(discipline) {

  if (discipline?.includes('_')) {
    return discipline
      ?.split('_') // Split the string into an array of words
      ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words back into a single string with spaces
  } else {
    // If there is no underscore, just capitalize the first letter of the string
    return discipline?.charAt(0)?.toUpperCase() + discipline?.slice(1);
  }
}


function getSelectedDisciplines(allDisciplines = [], selectedOptions = []) {
  return allDisciplines?.filter(discipline => selectedOptions?.includes(discipline.value))?.map(({ value, label }) => ({ value, label }));
}

const getValuesFunc = (newArr) => {
  let new_arr = [];
  if (Array?.isArray(newArr) && newArr?.length > 0) {
    new_arr = newArr?.map(item => {
      return item?.value
    })
  }
  return new_arr
}

// TODO (meeting req): Horse filter bug - ensure listDisciplines (b) is flat array {group,label,value}.
// If b is formatListArray output (grouped), this filter fails. Horse discipline (a) is string[].
function getByDisciplineFilterValues(a, b) {
  return b?.filter(item => a?.includes(item?.value))?.map(({ label, value }) => ({ label, value }));
}

function formatDate(timestamp) {
  if (!timestamp) {
    return null;
  }

  const date = new Date(timestamp * 1000);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  const formattedDate =
    (month < 10 ? "0" : "") +
    month +
    "/" +
    (day < 10 ? "0" : "") +
    day +
    "/" +
    year;

  return formattedDate;
}

function formatToMMDDYYYY(dateInput) {
  const mmddyyyyRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;

  if (typeof dateInput === 'string' && mmddyyyyRegex.test(dateInput)) {
    return dateInput;
  }

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}


function formatName(name) {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

function formatPhoneNumber(phone) {
  if (!phone) return "";
  let value = phone.replace(/\D/g, "").replace(/^1/, "");

  if (value.length > 6) {
    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    return `(${value.slice(0, 3)}) ${value.slice(3)}`;
  } else if (value.length > 0) {
    return `(${value}`;
  }

  return phone;
}

const seatSizes = [
  { label: "13", value: 13 },
  { label: "13.5", value: 13.5 },
  { label: "14", value: 14 },
  { label: "14.5", value: 14.5 },
  { label: "15", value: 15 },
  { label: "15.5", value: 15.5 },
  { label: "16", value: 16 },
];

const brandOptions = [
  { label: "Billy Cook", value: "billycook" },
  { label: "Cactus Saddlery", value: "cactussaddlery" },
];

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

/** Storefront route for a manufacturer (matches `src/routes/index.js`). */
function manufacturerListPath(brandName) {
  const bn = (brandName || "").toLowerCase();
  if (bn.includes("cactus")) return "/cactus";
  if (bn.includes("billy")) return "/billy-cook";
  return "/buy";
}

function isBillyCookBrandName(brandName) {
  const bn = (brandName || "").toLowerCase();
  return bn.includes("billy") || bn === "billycook";
}

function isCactusBrandName(brandName) {
  const bn = (brandName || "").toLowerCase();
  return bn.includes("cactus") || bn === "cactussaddlery";
}

const formatString = (s) => {
  if (typeof s !== 'string') {
    return s || "";
  }

  const upperS = s.toUpperCase();
  if (upperS === "SELL_LIVE") {
    return "Available";
  } else if (upperS === "SELL_NOT_LIVE") {
    return "Not Available";
  }

  const brandPh = "@@SADDLEFIT@@";
  s = s?.replace(/saddlefit/gi, brandPh);
  s = s?.replace(/_/g, " ");
  s = s?.replace(/([a-z])([A-Z])/g, '$1 $2');
  s = s?.replace(/([a-zA-Z])(\d)/g, '$1 $2');

  if (s?.toLowerCase() === "cactussaddlery") {
    return "Cactus Saddlery";
  }
  if (s?.toLowerCase() === "billycook") {
    return "Billy Cook";
  }

  s = s?.replace(/([a-zA-Z])saddle/gi, '$1 Saddle');

  return s
    ?.split(" ")
    ?.map((word) => {
      if (word === brandPh) return "SaddleFit";
      return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
    })
    ?.join(" ")
    ?.replace(/\bSaddle\s+fit\b/gi, "SaddleFit");
};


/** In-page anchor for Partner “Let us know” / request form (saddle-fit-website PartnerPage). */
const PARTNER_REQUEST_INFO_SECTION_ID = "partner-request-info";

function scrollToPartnerRequestInfo() {
  if (typeof document === "undefined") return;
  const el = document.getElementById(PARTNER_REQUEST_INFO_SECTION_ID);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  if (typeof window !== "undefined") {
    const hash = `#${PARTNER_REQUEST_INFO_SECTION_ID}`;
    if (window.location.hash !== hash) {
      window.history.replaceState(null, "", hash);
    }
  }
}

function parseBannerTs(v) {
  if (v == null || v === "") return 0;
  const num = typeof v === "number" ? v : parseInt(String(v), 10);
  return Number.isFinite(num) ? num : 0;
}

/** Oldest first: slot 0 / 1 align with CMS Banner 1 / Banner 2 for the same type. */
function sortBannerRowsByListSlot(rows) {
  if (!rows?.length) return [];
  return [...rows].sort((a, b) => {
    const ca = parseBannerTs(a?.createdAt);
    const cb = parseBannerTs(b?.createdAt);
    if (ca !== cb) return ca - cb;
    return String(a?.id ?? "").localeCompare(String(b?.id ?? ""));
  });
}

function pickBannerRowForSlot(rows, slotIndex) {
  const sorted = sortBannerRowsByListSlot(rows);
  if (
    typeof slotIndex !== "number" ||
    slotIndex < 0 ||
    slotIndex >= sorted.length
  ) {
    return undefined;
  }
  return sorted[slotIndex];
}

/** CMS banner background framing (object-fit / focal point). */
function getBannerMediaStyle(bannerItem) {
  const rawFit = bannerItem?.imageBackgroundSize;
  const objectFit = rawFit === "contain" ? "contain" : "cover";
  const pos =
    typeof bannerItem?.imageBackgroundPosition === "string" &&
    bannerItem.imageBackgroundPosition.trim()
      ? bannerItem.imageBackgroundPosition.trim()
      : "center center";
  return { objectFit, objectPosition: pos };
}

function getBannerSvgPreserveAspectRatio(bannerItem) {
  return bannerItem?.imageBackgroundSize === "contain"
    ? "xMidYMid meet"
    : "xMidYMid slice";
}

const handleRedirect = (url, options = {}) => {
  if (url == null) return;
  const u = String(url).trim();
  if (!u) return;
  const { navigate } = options;
  if (u.startsWith("#")) {
    const id = u.slice(1);
    if (id) {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
    if (typeof window !== "undefined" && window.location.hash !== u) {
      window.history.pushState(null, "", u);
    }
    return;
  }
  if (u.startsWith("/") && !u.startsWith("//")) {
    if (typeof navigate === "function") navigate(u);
    else if (typeof window !== "undefined") window.location.assign(u);
    return;
  }
  const formattedUrl =
    u.startsWith("http://") || u.startsWith("https://") ? u : `https://${u}`;
  window.open(formattedUrl, "_blank");
};

export {
  // isCompositeTypeElement,
  // isElement,
  compileRoute,
  compileTemplate,
  matchRoute,
  shallowEqual,
  fileInputToBlob,
  containsSpecialChars,
  validateEmail,
  isNumeric,
  formatListArray,
  formatSaddleDiscipline,
  getSelectedDisciplines,
  getValuesFunc,
  getByDisciplineFilterValues,
  formatDate,
  formatName,
  formatPhoneNumber,
  seatSizes,
  debounce,
  brandOptions,
  formatToMMDDYYYY,
  handleRedirect,
  getBannerMediaStyle,
  getBannerSvgPreserveAspectRatio,
  pickBannerRowForSlot,
  scrollToPartnerRequestInfo,
  PARTNER_REQUEST_INFO_SECTION_ID,
  formatString,
  manufacturerListPath,
  isBillyCookBrandName,
  isCactusBrandName,
}
